import { Bank } from '@treasury/domain/wires';
import { TmBaseComponent } from '@treasury/presentation';
import { TmSearchTermChangeEvent } from '@treasury/presentation/components/tm-list-header';
import { html, PropertyValues } from 'lit';
import { columnBodyRenderer, GridColumnBodyLitRenderer } from 'lit-vaadin-helpers';
import { customElement, property, state } from 'lit/decorators.js';
import { filterTableResults } from '../../../../utilities/table-result-filter';

export const tagName = 'creditor-banks-table';
@customElement(tagName)
export class CreditorBanksTable extends TmBaseComponent {
    @property({ type: Array })
    public banks: Bank[] = [];

    @state()
    private filteredBanks: Bank[] = [];

    @state()
    private selectedBank?: Bank;

    @state()
    private selectedAgentId = '';

    @state()
    private selectedInstructedAgentId = '';

    protected render() {
        return html`<tm-section>
            <tm-list-header
                .filterButton=${false}
                @search-term-change=${(e: TmSearchTermChangeEvent) => {
                    this.filterResults(e);
                }}
            ></tm-list-header>
            <vaadin-grid
                class="border-y"
                .items=${this.filteredBanks}
                @active-item-changed=${({ detail }: CustomEvent) => {
                    const selectedBank = detail.value ? detail.value : this.selectedBank;
                    this.dispatchEvent(
                        new CustomEvent('select-bank', {
                            detail: selectedBank,
                            bubbles: true,
                        })
                    );
                    this.dispatchEvent(new CustomEvent('close', { bubbles: true }));
                }}
            >
                <vaadin-grid-column
                    ${columnBodyRenderer(
                        this.renderBankData as GridColumnBodyLitRenderer<Bank>,
                        []
                    )}
                ></vaadin-grid-column>
            </vaadin-grid>
        </tm-section>`;
    }

    protected updated(_changedProperties: PropertyValues): void {
        if (_changedProperties.has('banks')) {
            this.filteredBanks = this.banks;
        }
        if (
            _changedProperties.has('selectedAgentId') ||
            _changedProperties.has('selectedInstructedAgentId')
        ) {
            this.filteredBanks = this.banks.filter(
                bank =>
                    bank.bankId !== this.selectedAgentId &&
                    bank.bankId !== this.selectedInstructedAgentId
            );
        }
    }

    private filterResults(e: CustomEvent) {
        this.filteredBanks = filterTableResults(e, this.banks, ['bankId', 'name', 'city', 'state']);
    }

    private renderBankData(bank: Bank) {
        return html`<div class="flex justify-between">
            <div>
                <div class="text-sm font-medium">${bank.name}</div>
                <div class="text-xs text-secondary">${bank.bankId}</div>
            </div>
            <div>
                <div class="text-sm font-medium">${bank.city}, ${bank.state}</div>
            </div>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CreditorBanksTable;
    }
}
